// Date helpers for the push review wireframe. Dates are ISO yyyy-mm-dd strings
// handled in UTC, so no time zone shifts a day.

export const TODAY = "2026-10-19" // the sheet's snapshot day, the Oct 19 meeting
export const LAST_MEETING = "2026-09-17"

const DAY_MS = 86400000

export function addDays(iso: string, days: number) {
  const d = new Date(iso + "T00:00:00Z")
  d.setUTCDate(d.getUTCDate() + days)
  return d.toISOString().slice(0, 10)
}

// First day of the month that is `months` after the month of `iso`.
export function addMonths(iso: string, months: number) {
  const d = new Date(iso.slice(0, 7) + "-01T00:00:00Z")
  d.setUTCMonth(d.getUTCMonth() + months)
  return d.toISOString().slice(0, 10)
}

export function daysBetween(from: string, to: string) {
  return Math.round((Date.parse(to) - Date.parse(from)) / DAY_MS)
}

export function formatDate(iso: string, options: Intl.DateTimeFormatOptions) {
  return new Date(iso + "T00:00:00Z").toLocaleDateString("en-US", { ...options, timeZone: "UTC" })
}

export const shortDate = (iso: string) => formatDate(iso, { month: "short", day: "numeric" })
export const monthYear = (iso: string) => formatDate(iso, { month: "short", year: "numeric" })
